import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import {
  InvoiceStatus,
  SearchInvoiceRowsFilterParameter
} from "@wingspanhq/wingspan-api-sdk";
import { selectorInvoiceRowsFilter } from "../../../selectors/selectorInvoiceRowsFilter";
import { InvoiceFilter } from "./types";

/**
 * Build the v3 `searchInvoiceRows` filter from the dashboard tab's status set
 * and the URL-driven filters (client + date ranges + free-text search).
 * Server-side only — no client-side filtering.
 */
export function createSearchRequest(
  filter: InvoiceFilter | undefined,
  statuses: InvoiceStatus[] | undefined
): SearchInvoiceRowsFilterParameter {
  const due = filter?.dueDateRange
    ? convertDateRangeToDates(filter.dueDateRange)
    : undefined;
  const paid = filter?.paidDateRange
    ? convertDateRangeToDates(filter.paidDateRange)
    : undefined;

  return selectorInvoiceRowsFilter({
    search: filter?.search,
    clientId: filter?.clientId,
    statuses,
    dueDateRange: due ? [due.start as Date, due.end as Date] : undefined,
    paidDateRange: paid ? [paid.start as Date, paid.end as Date] : undefined
  });
}
